

/******************************************************
    Ellipsis
******************************************************/
import $ from 'jquery';
import dotdotdot from 'jquery.dotdotdot';


export default function initEllipsis() {
	applyEllipsis();
}

function applyEllipsis() {
	// clear all previous ellipsis
	$("*").trigger("destroy.dot");

	// targets
	ellipsis(".cardList .card__text", 2);
}

function getLineHeight(el) {
	if ($(el).length) {
		var height = $(el).css("line-height").replace("px", "");
		if (isNumeric(height)) {
			return Math.ceil(height);
		} else {
			var font = $(el).css("font-size").replace("px", "") * 1.3;
			return Math.ceil(font);
		}
	}
	return 0;
}

function isNumeric(n) {
	return !isNaN(parseFloat(n)) && isFinite(n);
}

function ellipsis(target, lineCount) {
	var ellipsisHeight = getLineHeight(target) * lineCount;
	dotdot(target, ellipsisHeight);
	$(target).css("visibility", "visible");
}

function dotdot(target, ellipsisHeight) {
	$(target).dotdotdot({
		/*	The text to add as ellipsis. */
		ellipsis: '\u2026 ',

		/*	How to cut off the text/html: 'word'/'letter'/'children' */
		wrap: 'word',

		/*	Wrap-option fallback to 'letter' for long words */
		fallbackToLetter: true,

		/*	jQuery-selector for the element to keep and put after the ellipsis. */
		after: 'a.readmore',

		/*	Whether to update the ellipsis: true/'window' */
		watch: 'window',

        /*	Optionally set a max-height, can be a number or function.
            If null, the height will be measured. */
		height: ellipsisHeight,

		/*	Deviation for the height-option. */
		tolerance: 0,

		lastCharacter: {
			/*	Remove these characters from the end of the truncated text. */
			remove: [' ', ',', ';', '.', '!', '?'],
		}
	});
}

